// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__30ycb","headerWrapper":"style_headerWrapper__bCgUD","title":"style_title__m80C7","img":"style_img__-1XSz"};